import { render, staticRenderFns } from "./PhoneEightFive.vue?vue&type=template&id=db37ff1c&scoped=true"
import script from "./PhoneEightFive.vue?vue&type=script&lang=js"
export * from "./PhoneEightFive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db37ff1c",
  null
  
)

export default component.exports